module.exports = __webpack_public_path__ + "img/twitter.6fe4582a.svg";